import type { Session, SessionsFilter } from "@/features/coaching/models";
import {
  SESSION_STATUS,
  sessionSchema,
  subscribedSessionSchema,
} from "@/features/coaching/models";
import {
  parsePaginatedResponse,
  parseResponseData,
  privateAPI,
} from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { PaginationParams } from "@/shared/models";

const SESSION_ENDPOINT = "/sessions";

interface GetSessionParams {
  filter: SessionsFilter;
  pagination?: Partial<PaginationParams>;
}

export const getSessions = async ({ filter, pagination }: GetSessionParams) => {
  const response = await privateAPI.get(SESSION_ENDPOINT, {
    params: { filter, ...pagination },
  });

  return parsePaginatedResponse(response, sessionSchema.array());
};

export const subscribeToSession = async (id: Session["id"]) => {
  const { data } = await privateAPI.post<ServiceResponse<Session>>(
    `${SESSION_ENDPOINT}/${id}/subscription`,
  );

  return data.data;
};

export const getUpcomingSessions = async () => {
  const response = await privateAPI.get(`${SESSION_ENDPOINT}/subscribed`);

  return parseResponseData(response, subscribedSessionSchema.array());
};

export const unsubscribeToSession = async (id: Session["id"]) => {
  const { data } = await privateAPI.delete<ServiceResponse<Session>>(
    `${SESSION_ENDPOINT}/${id}/subscription`,
  );

  return data.data;
};

export const getOngoingSessions = async () => {
  const response = await privateAPI.get(SESSION_ENDPOINT, {
    params: { filter: { status: SESSION_STATUS.ONGOING } },
  });

  return parseResponseData(response, sessionSchema.array());
};
